import React from 'react';
import { Card, CardBody, CardText, Button } from 'reactstrap';
import './assets/CSS/levelcard.css';

const LevelCard = ({ level, description, portalTitle, portalContent, appTitle, appContent, onSelect, isSelected, topBarColor }) => {
    const bodyStyles = {
        title: {
            height: '115px'
        },
        portalTitle: {
            height: '145px',
            fontSize: '0.1em'
        },
        appTitle: {
            height: '150px'
        }
    };
    let className = "mb-2 level-card";
    if (isSelected) {
        className += " selected";
    }
    return (
        <Card className={className}>
            <div style={{ height: '8px', margin: '-20px', backgroundColor: topBarColor }} /> {/* Green bar */}
            <CardBody>
                <div style={bodyStyles.title} className="mt-2 mb-4">
                    <h1 className="text-center">{level}</h1>
                    <p className="text-center">{description}</p>
                </div>
                

                {/* Portal Section */}
                <Card className="mb-3 square-card stretch-card">
                    <CardBody className="pt-3" style={bodyStyles.portalTitle}>
                        <h5 style={{ marginBottom: '0px', fontSize: '1rem' }} className="text-center">{portalTitle}</h5>
                        <CardText style={{ fontSize: '0.9rem' }} className="text-center p-2">{portalContent}</CardText>
                    </CardBody>
                </Card>

                {/* App Section */}
                <Card className="position-relative square-card stretch-card">
                    <CardBody style={bodyStyles.appTitle}>
                        <h5 style={{ fontSize: '1rem' }} className="text-center">{appTitle}</h5>
                        <div style={{ fontSize: '0.9rem' }} className="card-text">{appContent}</div>
                    </CardBody>
                </Card>

                {/* Select Button */}
                <div className="text-center mt-3">
                    <Button className="grey-btn" onClick={onSelect}>SELECT</Button>
                </div>
            </CardBody>
        </Card>
    );
};



export default LevelCard;